import React, { useEffect, useState } from 'react';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	FormLabel,
	Stack,
	TextField,
} from '@mui/material';
import { BrokerGroupSelect } from '@/components/selects/BrokerGroupSelect';
import { OwnerMultiSelect } from '@/components/selects/OwnerSelect';
import { useGetAdminBrokerGroupsQuery, useGetAdminUsersQuery } from '@/features/user/userApi';

export const FeatureFlagAccessDialog = ({ flag, saving, onClose, onSave }) => {
	const [description, setDescription] = useState('');
	const [userIds, setUserIds] = useState([]);
	const [brokerGroupIds, setBrokerGroupIds] = useState([]);
	const { data: adminUsers = [] } = useGetAdminUsersQuery();
	const { data: adminBrokerGroups = [] } = useGetAdminBrokerGroupsQuery();

	useEffect(() => {
		setDescription(flag?.description ?? '');
		setUserIds(flag?.userIds ?? []);
		setBrokerGroupIds(flag?.brokerGroupIds ?? []);
	}, [flag]);

	return (
		<Dialog open={Boolean(flag)} onClose={saving ? undefined : onClose} fullWidth maxWidth='sm'>
			<DialogTitle>{flag?.feature}</DialogTitle>
			<DialogContent>
				<Stack spacing={2} sx={{ pt: 1 }}>
					<FormControl fullWidth>
						<FormLabel>Description</FormLabel>
						<TextField
							value={description}
							onChange={(event) => setDescription(event.target.value)}
							size='small'
							multiline
							minRows={2}
							fullWidth
						/>
					</FormControl>
					<FormControl fullWidth>
						<FormLabel>Users</FormLabel>
						<OwnerMultiSelect
							users={userIds}
							returnValue='id'
							availableUsers={adminUsers}
							onChange={(nextIds) => setUserIds(nextIds ?? [])}
						/>
					</FormControl>
					<FormControl fullWidth>
						<FormLabel>Broker groups</FormLabel>
						<BrokerGroupSelect
							multiple
							showAdmin
							showCheckbox
							showAllOption
							showClearOption
							availableGroups={adminBrokerGroups}
							brokerGroupId={brokerGroupIds}
							onChange={(nextIds) => setBrokerGroupIds(nextIds ?? [])}
						/>
					</FormControl>
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} disabled={saving}>
					Cancel
				</Button>
				<Button
					variant='contained'
					disabled={saving}
					onClick={() => onSave(userIds, brokerGroupIds, description)}
				>
					Save
				</Button>
			</DialogActions>
		</Dialog>
	);
};
